export default __webpack_public_path__ + "static/13_30-ce2731b1b1e1b32c9e26a5a2cc51b7a1.png";